module.exports = __webpack_public_path__ + "static/media/slide-1.e6c71b6b.jpg";